/* eslint-disable react/jsx-no-target-blank */
import React from 'react';

const Social = () => {
  return (
    <div className='home__social'>
        <a href='https://www.instagram.com/carljeromee/' className='home__social-icon' target='_blank'>
            <i class='uil uil-instagram'></i>
        </a>

        <a href='https://www.facebook.com/jeromeecarl' className='home__social-icon' target='_blank'>
            <i class='uil uil-facebook'></i>
        </a>

        <a href='https://www.linkedin.com/in/jerome-de-cinco-4b4904189/' className='home__social-icon' target='_blank'>
            <i class='uil uil-linkedin-alt'></i>
        </a>

    </div>
  )
}

export default Social
